<template>
  <div class="page" v-if="pool">
    <div class="page-main">
      <div class="page-header">
        <div class="col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1">
          <h1 class="page-title">Prize</h1>
          <breadcrumb
            name="PRIZE_SUMMARY_POOL_EDIT"
            :withLast.sync="pool.name"
          ></breadcrumb>
          <div class="page-title page-header-actions">
            <button
              type="button"
              class="btn btn-round btn-default mx-10"
              @click="goBack"
            >
              <i class="icon md-chevron-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
        </div>
      </div>
      <div class="page-content container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1">
            <div class="panel panel-bordered">
              <div class="panel-heading">
                <h3 class="panel-title">
                  Prize Pool Information - {{ pool.id }}
                </h3>
                <div class="panel-actions panel-actions-keep">
                  <h4>Type: {{ pool.type | capitalize }}</h4>
                </div>
              </div>
              <div class="panel-body">
                <form class="form-horizontal" v-if="pool">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <PoolName :pool="pool" @updated="fetchPool" />
                    </div>
                    <div class="form-group col-md-3">
                      <StatusDropdown :pool="pool" @updated="fetchPool" />
                    </div>
                  </div>
                  <hr />
                  <VendorSelector :pool="pool" @updated="fetchPool" />
                  <hr />
                  <div class="col-md-12">
                    <h4>Prize Details</h4>
                    <div class="px-10">
                      <PrizeDetail :pool="pool" @updated="fetchPool" />
                      <PrizeDescription :pool="pool" @updated="fetchPool" />
                      <PrizePicture :pool="pool" @updated="fetchPool" />
                      <RequireAddress :pool="pool" @updated="fetchPool" />
                    </div>
                  </div>
                  <hr />
                  <AvailableCondition :pool="pool" @updated="fetchPool" />
                </form>
              </div>
              <div class="panel-footer">
                <div class="d-flex justify-content-between"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prizepoolService } from "@/api/client";

import PoolName from "@/views/prize/pool/components/PoolName.vue";
import PrizeDetail from "@/views/prize/pool/components/PrizeName.vue";
import PrizePicture from "@/views/prize/pool/components/PrizePicture.vue";
import VendorSelector from "@/views/prize/pool/components/VendorSelector.vue";
import StatusDropdown from "@/views/prize/pool/components/StatusDropdown.vue";
import RequireAddress from "@/views/prize/pool/components/RequireAddress.vue";
import PrizeDescription from "@/views/prize/pool/components/PrizeDescription.vue";
import AvailableCondition from "@/views/prize/pool/components/AvailableCondition.vue";

export default {
  name: "PrizePoolEdit",

  data() {
    return {
      pool: null,
    };
  },

  components: {
    PoolName,
    PrizeDetail,
    PrizePicture,
    VendorSelector,
    StatusDropdown,
    RequireAddress,
    PrizeDescription,
    AvailableCondition,
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async fetchPool() {
      const id = this.$route.params.id;
      this.pool = await prizepoolService.getPrizePoolById(id);
    },
  },

  created() {
    this.fetchPool();
  },
};
</script>

<style lang="scss" scoped>
.panel-bordered > .panel-heading > .panel-title {
  padding-bottom: 10px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
